import * as React from "react";
import { forwardRef } from "react";
const SvgHoliday = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: 512, height: 512, x: 0, y: 0, viewBox: "0 0 682.667 682.667", style: {
  enableBackground: "new 0 0 512 512"
}, xmlSpace: "preserve", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "a", clipPathUnits: "userSpaceOnUse" }, /* @__PURE__ */ React.createElement("path", { d: "M0 512h512V0H0Z", fill: "#ffffff", opacity: 1, "data-original": "#000000" }))), /* @__PURE__ */ React.createElement("path", { d: "M0 0h182.295", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "matrix(1.33333 0 0 -1.33333 173.63 106.998)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("g", { clipPath: "url(#a)", transform: "matrix(1.33333 0 0 -1.33333 0 682.667)" }, /* @__PURE__ */ React.createElement("path", { d: "M0 0h82.172a7.66 7.66 0 0 0 7.66-7.66v-92.319h-497.31V-7.66A7.66 7.66 0 0 0-399.817 0h82.171", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(414.823 431.752)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h34.772", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(347.005 431.752)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h-66.299a7.66 7.66 0 0 0-7.66 7.66v281.271H423.35V7.66A7.66 7.66 0 0 0 415.69 0H35.134", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(81.305 42.84)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v0c-9.125 0-16.522 7.397-16.522 16.522v38.351c0 9.125 7.397 16.523 16.522 16.523 9.125 0 16.522-7.398 16.522-16.523V16.522C16.522 7.397 9.125 0 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(113.7 397.764)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v0c-9.125 0-16.522 7.397-16.522 16.522v38.351c0 9.125 7.397 16.523 16.522 16.523 9.125 0 16.522-7.398 16.522-16.523V16.522C16.522 7.397 9.125 0 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(398.3 397.764)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 21.783 57.194c.446 1.088 1.986 1.09 2.433.003L45.801 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(363.932 158.3)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h32.324", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(370.725 172.545)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-57.962c.641-.11 20.314 0 20.314 0", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(208.53 216.312)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-58.011", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(261.396 216.312)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-58.011", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(45.269 216.312)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-58.011", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(85.414 216.312)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0h40.145", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(45.269 188.301)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0v-55.322", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(298.424 214.538)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-15.511-8.609-27.785-22.268-28.023-4.546-.08-16.296-.124-16.296-.124s-.073 20.391-.073 28.209c0 6.422-.041 28.086-.041 28.086h15.944C-7.753 28.148 0 15.511 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(337.102 186.448)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 18.53-28.378L36.908-.147", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(429.823 216.312)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "m0 0 .073 29.633", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(448.28 158.3)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }), /* @__PURE__ */ React.createElement("path", { d: "M0 0c0-16.019-12.986-29.005-29.006-29.005-16.019 0-29.005 12.986-29.005 29.005 0 16.02 12.986 29.006 29.005 29.006C-12.986 29.006 0 16.02 0 0Z", style: {
  strokeWidth: 15,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeDasharray: "none",
  strokeOpacity: 1
}, transform: "translate(175.977 187.306)", fill: "none", stroke: "#ffffff", strokeWidth: 15, strokeLinecap: "round", strokeLinejoin: "round", strokeMiterlimit: 10, strokeDasharray: "none", strokeOpacity: "", "data-original": "#000000", opacity: 1 }))));
const ForwardRef = forwardRef(SvgHoliday);
export default ForwardRef;
